/* eslint-disable no-unused-vars, import/no-cycle */
import React from 'react';
import {
  Dialog, DialogContent, Slide, makeStyles, useMediaQuery,
} from '@material-ui/core';
import MenuProvider from './MenuProvider';

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);
const useStyle = makeStyles((theme) => ({
  scrollPaper: {
    alignItems: 'flex-end',

    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
    },
  },
  paper: {
    maxHeight: '90%',
    height: 'auto',
  },
  ItemContainer: {
    position: 'relative',

    '&+&': {
      marginTop: theme.spacing(2),
    },
  },
  magicCodeContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5),
  },
}));

export default ({
  isOpen,
  onClose,
  data,
}) => {
  const classes = useStyle();
  const isUpSm = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const fullScreen = !isUpSm;

  return (
    <Dialog
      classes={{
        scrollPaper: classes.scrollPaper,
        paper: classes.paper,
      }}
      open={isOpen}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      fullScreen={fullScreen}
      TransitionComponent={Transition}
    >
      <DialogContent>
        <MenuProvider {...data} isOpenOnNewTab={false} />
      </DialogContent>
    </Dialog>
  );
};
